export interface HeroCard {
  id: string;
  image: string;
  tag: string;
  title: string;
  excerpt: string;
  heat: string;
  discussion: string;
  time: string;
}

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  heatPercent: number;
  discussion: string;
  trend: "up" | "down" | "new" | "flat";
}

export interface TopicTag {
  label: string;
  count: string;
  size: "lg" | "md" | "sm";
}

export interface HeadlineItem {
  id: string;
  image: string;
  category: string;
  title: string;
  summary: string;
  heat: string;
  time: string;
}

export interface DiscussItem {
  rank: number;
  title: string;
  tag: string;
  comments: string;
  image: string;
}

export const mastheadNav = [
  { label: "今日头条", href: "#headlines" },
  { label: "TOP榜", href: "#top-ranking" },
  { label: "热度排行", href: "#top-ranking" },
  { label: "话题墙", href: "#topic-wall" },
  { label: "讨论最多", href: "#most-discussed" },
];

export const tickerItems = [
  "榜一易主：某顶流深夜动态登顶热度榜",
  "讨论最多：某S姓女星工作室回应冲上热评",
  "话题墙新增 12 个瓜点",
  "今日已更新 128 条爆料",
  "爆款头条：某综艺录制现场路透","热度飙升：某品牌官宣引发全网猜测",
];

export const siteStats = [
  { value: "128", label: "今日更新", unit: "条" },
  { value: "46", label: "在榜话题", unit: "个" },
  { value: "3.2", label: "参与讨论", unit: "万" },
  { value: "98.6", label: "榜首热度", unit: "万" },
];

export const heroCovers: HeroCard[] = [
  {
    id: "hero-main",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20abstract%20magazine%20cover%20art%20of%20luxurious%20red%20velvet%20theater%20curtains%20parting%20around%20a%20single%20golden%20spotlight%20beam%2C%20deep%20soft%20shadows%2C%20warm%20crimson%20and%20amber%20palette%2C%20high%20contrast%20cinematic%20lighting%2C%20glossy%20premium%20finish%2C%20minimalist%20negative%20space%2C%20no%20text%2C%20no%20people&width=900&height=1200&seq=hl-hero-main&orientation=portrait",
    tag: "今日头条",
    title: "热搜第一挂了整晚：某顶流深夜动态被扒出时间线，细节全对上了",
    excerpt:
      "从凌晨的一点小动静，到天亮时冲上榜首，这条爆料只用了六个小时。网友顺着时间线一条条比对，热度仍在往上涨。",
    heat: "98.6万",
    discussion: "1,243",
    time: "2 小时前",
  },
  {
    id: "hero-side-1",
    image: "https://readdy.ai/api/search-image?query=Crushed%20velvet%20fabric%20folds%20in%20deep%20burgundy%20with%20scattered%20gold%20flecks%2C%20warm%20soft%20shadows%2C%20abstract%20editorial%20texture%2C%20no%20text%2C%20no%20people%2C%20premium%20glossy%20finish%2C%20cinematic%20warm%20tones&width=700&height=700&seq=hl-hero-side-1&orientation=squarish",
    tag: "讨论最多",
    title: "工作室回应发出三分钟，评论区已经吵翻了",
    excerpt: "一句“不予置评”，被解读出三种意思。",
    heat: "62.4万",
    discussion: "3,108",
    time: "4 小时前",
  },
  {
    id: "hero-side-2",
    image: "https://readdy.ai/api/search-image?query=Molten%20gold%20liquid%20swirl%20flowing%20on%20a%20dark%20warm%20background%2C%20abstract%20luxury%20editorial%20art%2C%20crimson%20reflections%2C%20high%20contrast%20lighting%2C%20no%20text%2C%20no%20people&width=700&height=700&seq=hl-hero-side-2&orientation=squarish",
    tag: "热度飙升",
    title: "品牌连夜撤下联名海报，时间点耐人寻味",
    excerpt: "物料上午还在，下午就换了一批。",
    heat: "47.9万",
    discussion: "886",
    time: "5 小时前",
  },
  {
    id: "hero-side-3",
    image: "https://readdy.ai/api/search-image?query=Soft%20smoke%20wisps%20drifting%20through%20warm%20amber%20light%20with%20crimson%20glow%2C%20abstract%20atmospheric%20editorial%20image%2C%20dark%20background%2C%20no%20text%2C%20no%20people&width=700&height=700&seq=hl-hero-side-3&orientation=squarish",
    tag: "瓜点预警",
    title: "同一航班同一酒店，两张图被拼到了一起",
    excerpt: "粉丝找出原图，时间戳差了十个月。",
    heat: "39.2万",
    discussion: "742",
    time: "6 小时前",
  },
];

export const topRanking: RankItem[] = [
  {
    rank: 1,
    title: "某顶流深夜动态被扒出完整时间线，热搜挂了整晚",
    tag: "今日头条",
    heat: "98.6万",
    heatPercent: 100,
    discussion: "1,243",
    trend: "up",
  },
  {
    rank: 2,
    title: "工作室“不予置评”三分钟冲上热评，解读版本越来越多",
    tag: "讨论最多",
    heat: "62.4万",
    heatPercent: 72,
    discussion: "3,108",
    trend: "up",
  },
  {
    rank: 3,
    title: "品牌连夜撤下联名海报，时间点被反复放大",
    tag: "热度飙升",
    heat: "47.9万",
    heatPercent: 58,
    discussion: "886",
    trend: "new",
  },
  {
    rank: 4,
    title: "同一航班同一酒店，两张图的时间戳对不上",
    tag: "瓜点预警",
    heat: "39.2万",
    heatPercent: 48,
    discussion: "742",
    trend: "down",
  },
  {
    rank: 5,
    title: "综艺录制路透流出，现场座位顺序成了新线索",
    tag: "爆款头条",
    heat: "33.5万",
    heatPercent: 41,
    discussion: "615",
    trend: "up",
  },
  {
    rank: 6,
    title: "旧采访被翻出，一句口误如今成了关键证据",
    tag: "考古现场",
    heat: "28.1万",
    heatPercent: 34,
    discussion: "508",
    trend: "flat",
  },
  {
    rank: 7,
    title: "同款单品被扒，博主连夜删除三个月前的种草",
    tag: "细节党",
    heat: "21.7万",
    heatPercent: 26,
    discussion: "377",
    trend: "down",
  },
  {
    rank: 8,
    title: "粉丝后援会临时改口风，公告发出又秒删",
    tag: "新瓜入榜",
    heat: "16.3万",
    heatPercent: 19,
    discussion: "264",
    trend: "new",
  },
];

export const rankFeature = {
  image: "https://readdy.ai/api/search-image?query=Abstract%20golden%20trophy%20like%20sculptural%20form%20on%20a%20marble%20podium%20under%20a%20crimson%20spotlight%2C%20luxury%20magazine%20cover%20art%2C%20warm%20tones%2C%20deep%20soft%20shadows%2C%20no%20text%2C%20no%20people&width=800&height=800&seq=hl-rank-feature&orientation=squarish",
  title: "登顶只用了 6 小时",
  desc: "从被发出到冲上榜首，这条爆料的热度曲线几乎是一条直线。点击与讨论双双走高，暂未看到降温迹象。",
  meta: "更新时间 06:12 · 热度仍在上涨",
};

export const topicTags: TopicTag[] = [
  { label: "顶流塌房", count: "328 条", size: "lg" },
  { label: "工作室回应", count: "276 条", size: "lg" },
  { label: "时间线对比", count: "214 条", size: "md" },
  { label: "品牌撤物料", count: "188 条", size: "md" },
  { label: "同款被扒", count: "163 条", size: "md" },
  { label: "路透流出", count: "141 条", size: "sm" },
  { label: "后援会改口", count: "122 条", size: "sm" },
  { label: "旧采访考古", count: "98 条", size: "sm" },
  { label: "深夜动态", count: "87 条", size: "sm" },
  { label: "秒删公告", count: "76 条", size: "sm" },
  { label: "同航班同酒店", count: "64 条", size: "sm" },
  { label: "评论区开撕", count: "58 条", size: "sm" },
  { label: "细节党上线", count: "43 条", size: "sm" },
  { label: "瓜点预警", count: "31 条", size: "sm" },
];

export const headlineFeed: HeadlineItem[] = [
  {
    id: "head-1",
    image: "https://readdy.ai/api/search-image?query=Champagne%20glass%20silhouette%20with%20warm%20golden%20bokeh%20lights%2C%20abstract%20celebration%20editorial%20photography%2C%20dark%20warm%20background%2C%20crimson%20tones%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=hl-head-1&orientation=landscape",
    category: "今日头条",
    title: "杀青宴照片流出，现场站位比剧情还精彩",
    summary: "合照里谁站中间、谁临时换位，被网友逐帧分析了一遍。",
    heat: "31.4万",
    time: "1 小时前",
  },
  {
    id: "head-2",
    image: "https://readdy.ai/api/search-image?query=Layered%20torn%20paper%20revealing%20crimson%20underneath%2C%20abstract%20editorial%20collage%20art%2C%20warm%20gold%20edges%2C%20deep%20soft%20shadows%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=hl-head-2&orientation=landscape",
    category: "爆款头条",
    title: "被删的那条动态，缓存里还留着截图",
    summary: "有人手快存了图，评论区已经拼出完整上下文。",
    heat: "27.8万",
    time: "2 小时前",
  },
  {
    id: "head-3",
    image: "https://readdy.ai/api/search-image?query=Flowing%20silk%20ribbon%20in%20warm%20crimson%20and%20gold%20light%2C%20abstract%20elegant%20editorial%20image%2C%20deep%20dark%20background%2C%20soft%20shadows%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=hl-head-3&orientation=landscape",
    category: "热度飙升",
    title: "同款配饰第三次出现，粉丝开始倒推时间",
    summary: "三次露面的间隔刚好对上行程，巧合还是必然？",
    heat: "23.6万",
    time: "3 小时前",
  },
  {
    id: "head-4",
    image: "https://readdy.ai/api/search-image?query=Crystal%20prism%20refracting%20warm%20light%20onto%20a%20dark%20surface%2C%20abstract%20luxury%20editorial%20photography%2C%20amber%20and%20crimson%20glow%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=hl-head-4&orientation=landscape",
    category: "话题墙",
    title: "一条旧评论被顶上来，牵出另一段往事",
    summary: "原本沉底两年的留言，昨晚突然被顶到最前排。",
    heat: "18.9万",
    time: "4 小时前",
  },
];

export const mostDiscussed: DiscussItem[] = [
  {
    rank: 1,
    title: "工作室“不予置评”到底几个意思？三种解读吵到现在",
    tag: "讨论最多",
    comments: "3,108",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20vintage%20microphone%20in%20warm%20spotlight%20glow%2C%20abstract%20editorial%20photo%2C%20dark%20background%2C%20crimson%20and%20gold%20tones%2C%20no%20text%2C%20no%20people&width=400&height=400&seq=hl-discuss-1&orientation=squarish",
  },
  {
    rank: 2,
    title: "时间线党整理出完整对照表，评论区补充了三条细节",
    tag: "细节党",
    comments: "2,274",
    image: "https://readdy.ai/api/search-image?query=Warm%20bokeh%20city%20night%20lights%20blurred%20abstract%2C%20amber%20and%20crimson%20tones%2C%20dark%20background%2C%20no%20text%2C%20no%20people&width=400&height=400&seq=hl-discuss-2&orientation=squarish",
  },
  {
    rank: 3,
    title: "品牌撤海报这事儿，公关圈的朋友怎么看的？",
    tag: "行业视角",
    comments: "1,562",
    image: "https://readdy.ai/api/search-image?query=Melting%20candle%20wax%20in%20warm%20amber%20tones%20with%20soft%20shadows%2C%20abstract%20editorial%20texture%2C%20dark%20background%2C%20no%20text%2C%20no%20people&width=400&height=400&seq=hl-discuss-3&orientation=squarish",
  },
  {
    rank: 4,
    title: "后援会公告秒删，粉丝内部也开始分成两派",
    tag: "粉丝前线",
    comments: "1,088",
    image: "https://readdy.ai/api/search-image?query=Blurred%20spotlight%20beams%20crossing%20in%20a%20dark%20theater%2C%20warm%20crimson%20and%20gold%2C%20abstract%20atmospheric%20image%2C%20no%20text%2C%20no%20people&width=400&height=400&seq=hl-discuss-4&orientation=squarish",
  },
];